/* GENERATED from src/js/ndog-founder-teaser.js — edit the source, then run `make js`. Never edit this file by hand. */
/*
  ndog-founder-teaser.js
  Self-contained web component for the NDOG Founder Teaser CTA.
  Intercepts the CTA click and deep-links into the ndog-mounted-tabs system:
  smooth-scrolls to the tabs bar (respecting its sticky offset) and sets the URL
  hash so the tabs component's existing hashchange listener activates the target
  tab. Falls back to plain anchor scrolling when no tabs are present.
  No dependencies. Listeners are cleaned up in disconnectedCallback.
*/
if (!customElements.get('ndog-founder-teaser')) {
  customElements.define(
    'ndog-founder-teaser',
    class NdogFounderTeaser extends HTMLElement {
      // Bind the CTA click; bail out cleanly if there is no link.
      connectedCallback() {
        this.link = this.querySelector('.ndog-founder-teaser__cta');
        if (!this.link) return;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onClick = this.handleClick.bind(this);
        this.link.addEventListener('click', this.onClick);
      }

      // Remove the listener so nothing lingers when the section is removed.
      disconnectedCallback() {
        if (this.link && this.onClick) this.link.removeEventListener('click', this.onClick);
      }

      // Route the click to the tabs system, or fall back to a normal anchor.
      handleClick(event) {
        const key = (this.link.dataset.target || '').trim();
        if (!key) return;

        const behavior = this.reduceMotion ? 'auto' : 'smooth';
        const tabs = document.querySelector('ndog-mounted-tabs');

        if (tabs) {
          // Tabs present: scroll to the bar, then activate via the hash.
          event.preventDefault();
          this.scrollToTabs(tabs, behavior);
          const hash = `#${key}`;
          // Setting an unchanged hash fires no event — the scroll above already
          // covers that case (the target tab is already active).
          if (window.location.hash !== hash) window.location.hash = hash;
          return;
        }

        // No tabs on the page: scroll to a matching anchor if one exists.
        const anchor = document.getElementById(key);
        if (anchor) {
          event.preventDefault();
          anchor.scrollIntoView({ behavior, block: 'start' });
          return;
        }

        // Neither tabs nor a matching anchor — do nothing (avoid a dead hash jump).
        event.preventDefault();
      }

      // Scroll so the tabs section sits at the top, minus its sticky offset.
      scrollToTabs(tabs, behavior) {
        const wrapper = tabs.closest('.shopify-section') || tabs;
        // Read the live sticky offset from the wrapper's resolved `top` so this follows the
        // active mobile/desktop breakpoint (CSS is the single source of truth). 0 when not sticky.
        const offset = parseFloat(getComputedStyle(wrapper).top) || 0;
        const top = window.scrollY + wrapper.getBoundingClientRect().top - offset;
        window.scrollTo({ top: Math.max(0, top), behavior });
      }
    }
  );
}
